// Libraries
import { Fragment } from 'react';
// Utils
import { FleetPerformanceAuthorization, FleetRatingsAuthorization } from '@constants/index';
// Types
import { FeatureProps } from './Feature.types';
import { useAuthorization } from '@hooks/index';

const FeatureMerged = {
  ...FleetPerformanceAuthorization,
  ...FleetRatingsAuthorization,
};

/**
 *
 * The objective of the Feature component is to conditionally
 * render its children based on whether a specific feature is active or not,
 * taking into account the current user session and feature flags configuration.
 * @component
 * @param {FeatureProps} featureProps
 * @returns {ReactElement}
 */
export const Feature = ({ children, feature }: FeatureProps) => {
  const { getAuthorization } = useAuthorization(FeatureMerged);

  const auth = getAuthorization(FeatureMerged[feature]);

  const isActive: boolean = auth[feature];

  return <Fragment>{isActive && children}</Fragment>;
};
